import { useState } from "react";
import SizeGroupSets from "./SizeGroupSets";
import SProductSizes from "./SProductSizes";

/**
 * Products -> Size Sets (user, 2026-10-27; was the "Sizes" tab):
 *   All Sizes   the sizes list as it was (SProductSizes)
 *   Group Sets  sets made from those sizes (SizeGroupSets)
 */
const SUB_TABS = [
  { id: "all", label: "All Sizes" },
  // Was "Group Sets" (renamed, user 2026-10-30).
  { id: "groups", label: "Size Sets" },
];

export default function SizeSetsLayout() {
  const [tab, setTab] = useState("all");
  return (
    <div>
      <div className="btn-group mb-2" role="group" aria-label="Size Sets">
        {SUB_TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`btn btn-sm border-primary ${
              tab === t.id ? "btn-primary" : "bg-white text-primary"
            }`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "all" ? <SProductSizes /> : <SizeGroupSets />}
    </div>
  );
}
